/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button/Button";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth/withWidth";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Menu from "@material-ui/core/Menu/Menu";
import ClickAwayListener from "@material-ui/core/ClickAwayListener/ClickAwayListener";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Dialog from "@material-ui/core/Dialog";
import {
  ConfigurateDesignerImageIcon,
  ConfigurateDesignerTextIcon,
  CloseMenuIcon,
} from "../../../../../Icons";
import ElementMenu from "./ElementMenu";
import MobileMenuStep from "../../../../Shared/Components/MobileMenuStep";

const styles = (theme) => ({
  optionsMenu: {
    pointerEvents: "none",

    "& .MuiPaper-root": {
      pointerEvents: "all",
      minWidth: 280,
      maxWidth: 280,
      borderRadius: 0,
    },
    "& .MuiList-root": {
      //  width: "auto",
      pointerEvents: "all",
      padding: `${theme.spacing(4)}px ${theme.spacing(6)}px`,
      paddingTop: 40,
      // paddingTop: theme.spacing(1) + 24,
      display: "flex",
      flexDirection: "column",
    },
  },
  closeButton: {
    borderRadius: 100,
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    minWidth: 14,
    padding: 4,
    marginTop: -4,
    marginRight: -4,
    "&:hover": {
      boxShadow: "none",
      background: "#F2F2F2",
    },
    "&:active, &:focus": {
      boxShadow: "none",
      background: "#C9C9C9",
    },
  },

  menuButton: {
    borderRadius: 0,
    border: "1px solid #BFB8AF",
    boxShadow: "none",
    fontWeight: "bold",
    textTransform: "unset",
    background: theme.palette.menuBtn.bg,
    color: theme.palette.menuBtn.text,
    margin: `${theme.spacing(0.5)}px 0px`,
    "& .material-icons": {
      color: theme.palette.menuBtn.text,
    },
    "&:hover": {
      background: "#F2F2F2",
      color: theme.palette.menuBtn.pressed,
      boxShadow: "none",
    },
    "&:focus, &:active": {
      background: "#C9C9C9",
      color: theme.palette.menuBtn.pressed,
      boxShadow: "none",
    },
  },
  buttonIcon: {
    paddingRight: theme.layout.buttonIcon.paddingRight,
  },
  radioHeading: {
    fontSize: 16,
    fontWeight: "bold",
  },
  radioFormControl: {
    fontSize: 14,
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 16,
    },

    "& .MuiButtonBase-root": {
      padding: "6.5px 9px",
      color: theme.layout.radio.color,
    },
    "& .MuiTypography-root": {
      fontSize: 14,
      [theme.breakpoints.up("sm")]: {
        fontSize: 14,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: 14,
      },
      [theme.breakpoints.up("xl")]: {
        fontSize: 16,
      },
    },
  },
  detailList: {
    padding: 0,
    margin: theme.spacing(3),
  },
});

class AddVisualElement extends React.Component {
  static propTypes = {
    onAddTextClick: PropTypes.func,
    onAddImageClick: PropTypes.func,
    onImageFileSelected: PropTypes.func,
    boxed: PropTypes.bool,
    classes: PropTypes.object,
    width: PropTypes.string,
    components: PropTypes.shape({
      ButtonContainer: PropTypes.elementType.isRequired,
    }).isRequired,
    hasLastEditedDesignArea: PropTypes.bool,
  };

  static defaultProps = {
    boxed: false,
    classes: {},
    components: {
      ButtonContainer: Grid,
    },
  };

  constructor(props) {
    super(props);
    this.callToActionRef = React.createRef();
    this.state = {
      hideMenu: false,
      optionRef: null,
      selectedProductionMethod: null,
    };
  }

  componentDidUpdate = (prev) => {
    if (prev.valueProductionMethod !== this.props.valueProductionMethod) {
      this.setState({
        selectedProductionMethod: this.props.valueProductionMethod
          ? this.props.valueProductionMethod.identifier
          : null,
      });
    }
    if (prev.imageDialogOpen !== this.props.imageDialogOpen) {
      this.setState({ hideMenu: !!this.props.imageDialogOpen });
    } else if (prev.selectedObject !== this.props.selectedObject) {
      if (this.props.selectedObject) {
        this.setState({
          hideMenu: !!(this.props.selectedObject.type === "Text"),
        });
      } else {
        this.setState({ hideMenu: false });
      }
    }
    // Does not need to be cleared
    if (prev.selectedDesignArea !== this.props.selectedDesignArea) {
      if (_.isEmpty(this.props.selectedDesignArea)) {
        this.setState({ optionRef: null });
      } else if (this.props.optionRefs.length > 0) {
        const obj = this.props.optionRefs.find(
          (o) => o.identifier === this.props.selectedDesignArea.identifier
        );
        if (obj) {
          this.setState({
            optionRef: obj.value,
            optionRefIdentifier: obj.identifier,
          });
        }
      }
      // this.setState({optionRef: })
    }
  };

  render() {
    const {
      classes,
      width,
      onAddImageClick,
      onAddTextClick,
      closeDesignArea,
      selectedDesignArea,
      handleChangeDesignArea,
      handleProductionMethodChange,
      doDisplayMobile,
      selectedObject,
      currentModalContentOption,
      setModalContentOption,
      modalContentOptions,
      setDisplayDesignerMobilePicker,
    } = this.props;
    const _closeDesignArea = () => {
      if (currentModalContentOption) {
        setModalContentOption(modalContentOptions.RENDER_OVERVIEW);
      }
      closeDesignArea();
    };
    const {
      hideMenu,
      optionRef,
      selectedProductionMethod,
      optionRefIdentifier,
    } = this.state;
    const closeMenu = () => {
      this.setState({ hideMenu: false });
      _closeDesignArea();
    };
    const onAddImageClickFunc = () => {
      this.setState({ hideMenu: true });
      onAddImageClick();
    };

    const renderMobileStep = () => (
      <div className={classes.detailList}>
        <ElementMenu
          selectedProductionMethod={selectedProductionMethod}
          onAddImageClickFunc={() => {
            setModalContentOption(modalContentOptions.RENDER_EDITGRAPHICS);
            onAddImageClickFunc();
          }}
          handleProductionMethodChange={this.props.handleChangeProductionMethod}
          onAddTextClick={() => {
            setModalContentOption(modalContentOptions.RENDER_EDITTEXT);
            onAddTextClick();
          }}
          selectedDesignArea={selectedDesignArea}
        />
      </div>
    );

    if (!isWidthUp("sm", width)) {
      if (Object.keys(selectedDesignArea).length > 0) {
        return (
          <>
            <MobileMenuStep
              doDisplayDesignArea
              doDisplay
              renderStep={() => <></>}
              heading={selectedDesignArea.title}
              backFunc={() => {
                setDisplayDesignerMobilePicker(true);
                setModalContentOption(modalContentOptions.RENDER_ITEMMENU);
              }}
              closeFunc={null}
            />
            <MobileMenuStep
              doDisplay={
                doDisplayMobile &&
                currentModalContentOption ===
                  modalContentOptions.RENDER_ITEMMENU
              }
              renderStep={renderMobileStep}
              heading={selectedDesignArea.title}
              backFunc={_closeDesignArea}
              closeFunc={null}
            />
          </>
        );
      }
      return <></>;
    }
    const isOpen =
      !hideMenu &&
      !!optionRef &&
      !!selectedDesignArea &&
      optionRefIdentifier === selectedDesignArea?.identifier;

    return (
      <Menu
        className={classes.optionsMenu}
        onCancel={closeMenu}
        onClose={closeMenu}
        open={isOpen}
        keepMounted
        getContentAnchorEl={null}
        anchorEl={optionRef}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            // height 32px -  half of minheight
            marginTop: `${32 / 2}px`,
          },
        }}
      >
        <Button
          className={classes.closeButton}
          onClick={closeMenu}
          color="inherit"
        >
          <CloseMenuIcon />
        </Button>
        <ElementMenu
          selectedProductionMethod={selectedProductionMethod}
          onAddImageClickFunc={onAddImageClickFunc}
          handleProductionMethodChange={this.props.handleChangeProductionMethod}
          onAddTextClick={onAddTextClick}
          selectedDesignArea={selectedDesignArea}
        />
      </Menu>
    );
  }
}

export default withWidth({ initialWidth: "lg" })(
  withStyles(styles, { name: "AddVisualElement" })(AddVisualElement)
);
